import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import { SupabaseRealtimeProvider } from '@/hooks/supabase-realtime-context'
import { SyncManagerProvider } from '@/hooks/sync-manager-context'
import { Toaster } from '@/components/ui/sonner.tsx'
import { ConfirmProvider } from '@/components/confirmation'
import { queryClient } from '@/clients/queryclient.ts'
import { DexieProvider } from '@/db/dexie-context.tsx'
import { apiUrl, env } from '@/env.ts'
import { AuthProvider } from '@/features/auth/auth-context'
import { Identifier } from '@/features/auth/identifier.tsx'

const posthogOptions: Partial<PostHogConfig> = {
  api_host: apiUrl('/ingest'),
  ui_host: 'https://us.posthog.com',
  capture_exceptions: true,
  debug: import.meta.env.MODE === 'development',
}

export const Providers: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <PostHogProvider
      apiKey={
        import.meta.env.MODE === 'production'
          ? env.VITE_PUBLIC_POSTHOG_KEY!
          : ''
      }
      options={posthogOptions}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SupabaseRealtimeProvider>
            <DexieProvider>
              <SyncManagerProvider>
                <ConfirmProvider>{children}</ConfirmProvider>
                <Identifier />
              </SyncManagerProvider>
            </DexieProvider>
          </SupabaseRealtimeProvider>
        </AuthProvider>
      </QueryClientProvider>
      <Toaster position="top-center" />
    </PostHogProvider>
  )
}
